//load scripts
jQuery( document ).ready(function($) {

	if( $('#map').length ) {
		$('body').addClass('is-map');
	}
	loadPins();

	window.activeInfoBox = false;
	window.markerClicked = false;

	var isMobile = false; //initiate as false
	// device detection
	if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) 
	    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) isMobile = true;

	$(window).on('scroll', function(e){
		if( activeInfoBox !== false && markerClicked !== false ) {
			activeInfoBox.show();
		}
	});

	function clearConsole() {
		if( $('.console-wrapper').text().length > 700 ) {
			$('.console-wrapper').text("");
		}
	}

	function loadPins() {

		$.ajax({ 
		   url: "/wp-json/wp/v2/prakse-api?per_page=100",
		   success: function(data){        
		     initPins(data, true);
		   }
		});
	}

	//Initialize markers and clusters on the map
	function initPins(data, onload ) {

		if(onload === undefined){
		    onload = true;
		}

		var locations = getLocationData(data);

		populatePins( locations, data, onload );

	}

	//Get all data of locations
	function getLocationData(data) {

		var locations = [];
		$.each(data, function(i, el) {
			var x = el.koordinate.x;
			var y = el.koordinate.y;
			var pozicija = el.koordinate.pozicija;
			var id = el.id;
			var name = el.koordinate.name;

			var coordinates = getIndexCoordinates(x, y, locations);
			if( coordinates === false ) {
				locations.push({ 
					x: x,
					y: y,
					ids: [id],
					names: [name],
					pozicija: pozicija
				});
			} else {
				locations[coordinates].ids.push(id);
				locations[coordinates].names.push(name);

				locations[coordinates] = {
					x: x,
					y: y,
					ids: locations[coordinates].ids,
					names: $.unique(locations[coordinates].names),
					pozicija: pozicija
				};
			}
		});


		return locations;
	}

	function populatePins( locations, data, onload ) {

		var infos = "<div class='all-infos'>";

		$.each(locations, function(index, val) {
			infos += shortInfoHtml(val.ids, data, index);
			var singleMarker = "<div id='index-" + index + "' data-ids='" + val.ids + "' class='marker " + ( val.ids.length > 3 ? "multiple" : "" ) + "'>" + val.ids.length + "</div>";

			var cityNames = "<div id='city-names-"+ index +"' class='city-names'>";
			$.each(val.names, function(index, val){
				cityNames += "<span>" + val + "</span>";
			});
			cityNames += "</div>";

			$("#map").append( singleMarker );
			$("#map").append( cityNames );

			var leftName, topName, textAlign;
			if( val.pozicija == "Levo" ) {
				leftName = "calc( " + ( val.x / 7 ) + "% - " + ( $( "#city-names-" + index ).width() + 12 ) + "px )";
				topName = "calc( " + ( val.y / 3.88 ) + "% + 6px )";
				textAlign = "right";
			} else if( val.pozicija == "Spodaj" ) {
				leftName = "calc( " + ( val.x / 7 ) + "% - " + ( $( "#city-names-" + index ).width()/2 - 10 ) + "px )";
				topName = "calc( " + ( val.y / 3.88 ) + "% + 35px )";
				textAlign = "center";
			} else {
				leftName = "calc( " + ( val.x / 7 ) +"% + 30px )";
				topName = "calc( " + ( val.y / 3.88 ) + "% + 6px )";
				textAlign = "left";
			}
			
			$( "#index-" + index ).css({"left": ( val.x / 7 ) + '%', "top": ( val.y / 3.88 ) + '%' });
			$( "#city-names-" + index ).css({
				"left": leftName,
				"top": topName,
				"text-align": textAlign
			});
		});

		infos += "</div>";

		if(onload) {
			$('.map-wrapper').after(infos);
			if( $('#map').data('dejavnost') ) {
				repopulateWithCategory($('#map').data('dejavnost'));
				$(".filter-dejavnosti select").val($('#map').data('dejavnost'))
			}
		} else {
			$('.all-infos').remove();
			$('.map-wrapper').after(infos);
		}

		//Open Info Box when click on marker
		$('.marker').click(function(){

			var id = $( this ).attr('id').split('-')[1];
			var infoBox = $('#info-'+id);
			window.activeInfoBox = infoBox;
			window.markerClicked = true;

			if( infoBox.is(":visible") ){
				return;
			}

			var arrow = infoBox.find('.trikotnik');
			var positions = calculatePositions( $( this ), infoBox, arrow );

			$('.info-box').hide();

			infoBox.css({
				'display':'inline-block',
				'left': positions.left,
				'top': positions.top,
			});

			if( !isMobile ) {
				infoBox.addClass('animated bounceIn');
			}

			$(window).on('click', function(e){
				if( !$(e.target).hasClass('info-box') && !$(e.target).parents('.info-box').length && e.target.id != 'index-'+id && !$(e.target).hasClass('dejavnost-info') && !$(e.target).parents('.dejavnost-info').length) {
					window.activeInfoBox = false;
					window.markerClicked = false;
					$('#info-'+id).hide();
					arrow.removeClass('left');
					arrow.removeClass('hide');
				}
				if( $(e.target).hasClass('close-box') ) {
					$('.info-box').hide();
				}
			});

			$('.info-link').on('click', function(){
				var id = $( this ).data('id');
				$.ajax({ 
					url: "/wp-json/wp/v2/prakse-api/" + id,
					success: function(data){        
						showSideInfo(data);
					}
				});
			});
		});

		$('#map').on('click', function(e){
			if( e.target.id == 'map' ){
				window.activeInfoBox = false;
				window.markerClicked = false;
				$('.info-box').hide();
			}
		});

	}

	function calculatePositions( marker, infoBox, arrow ) {

		var position = marker.position();
		var mapWrapper = $('.map-wrapper');
		var top = position.top - mapWrapper.height() - ( infoBox.outerHeight() / 2);
		var left = position.left - ( ( $('#map').width() - $( document ).width() ) / 2 ) - infoBox.outerWidth() - 40;
		
		if( $( document ).width() > 991 ) {
			if( top < - mapWrapper.height() + 170 ) {
				arrow.css({
					top: marker.offset().top - 70
				});
				top = 220 - mapWrapper.height();
			}
			if( left <= 0 ) {
				left += 388;
				arrow.addClass('left');
			}
		} else if( $( document ).width() <= 768 ) {
			top = position.top - mapWrapper.height() + 40;
			left = marker.offset().left - 125;
			if ( left <= 0 ) {
				left = 5;
			}
			if ( left > $( document ).width() - 290 ) {
				left = $( document ).width() - 290;
			}
			arrow.addClass('hide');
		} else if( $( document ).width() <= 991 ) {
			if( top < - mapWrapper.height() + 30 ) {
				arrow.css({
					top: marker.offset().top - 70
				});
				top = 100 - mapWrapper.height();
			}
			if( left <= 0 ) {
				left += 388;
				arrow.addClass('left');
			}
		}

		return {
			left: left,
			top: top
		}
	}

	function shortInfoHtml( ids, data, index ) {
		var infos = getShortInfos( ids, data );
		var output = "<div id='info-" + index + "' class='info-box'><div class='close-box'></div><div class='inner-box'>";
		$.each(infos, function(index, val) {
			output += "<div class='single-info' data-category='"+ val.dejavnost[0] +"'>";
			output += "<a href='javascript:;' data-id='" + val.id + "' class='info-link'><div class='info-title'>" + val.title.rendered  + "</div></a>";
			output += "<div class='info-lokacija'>" + val.meta.ime_lokacije[0] + "</div>";
			output += "</div>";
		});
		output += "</div><div class='trikotnik'></div></div>";
		return output;
	}

	function getShortInfos( ids, data ) {
		return data.filter(function(el) {
			return (ids.indexOf(el.id) >= 0);
		});
	}

	//Get index of matching koordinates in array
	function getIndexCoordinates(x, y, locations) {
		var index = false;
		$.each(locations, function(i, el) {
			if( el.x == x && el.y == y ) {
				index = i;
				return;
			}
		});
		return index;
	}

	//Populate sidebar with multiple prakse 
	function populateMultipleMarkers(ids) {
		var allData = [];
		ids.forEach(function(i, el) {
			$.ajax({ 
			   url: "/wp-json/wp/v2/prakse-api/" + el,
			   async: false,
			   success: function(data){        
			     allData.push(data);
			     if( i == ids.length - 1 ) {
			     	showSideInfo(allData);
			     }
			   }
			});
		});
	}

	//Opens sidebar with project details
	function showSideInfo(data) {
		showDetailsMarker(data);
		$('.dejavnost-info').animate({
			right: 0,
		}, 300, function() {
			$('body.is-map').on('click', function(e){
				if( !$(e.target).hasClass('info-box') && !$(e.target).parents('.info-box').length && !$(e.target).hasClass('dejavnost-info') && !$(e.target).parents('.dejavnost-info').length ) {
					window.activeInfoBox = false;
					window.markerClicked = false;
					$('.info-box').hide();
					closeSideDetails();
				}
			});
		});
	}

	//Populates sidebar with project data
	function showDetailsMarker(data) {

		var singleInfo = $('.dejavnost-info .single-info');

		//Populate first
		singleInfo.find('.title').text(data.title.rendered);
		if( data.featured_img.medium ) {
			singleInfo.find('.feat-img').html("<a href='" + data.link + "'><img src='" + data.featured_img.medium + "'></a>");
		} else {
			singleInfo.find('.feat-img').html("");
		}
		
		singleInfo.find('.excerpt').html(data.excerpt.rendered);
		singleInfo.find('.excerpt > p').append("...");
		singleInfo.find('.preberi-vec').attr("href", data.link);


	}

	function closeSideDetails() {
		$('body.is-map').off();
		$('.dejavnost-info').animate({
			right: '-350px',
		}, 300 );
	}

	function filterFeed(dejavnostID) {
		if( $('.praksa-feed').length ) {

			if( dejavnostID == 0 ) {
				$('.praksa-feed').show();
			} else {
				$('.praksa-feed').each(function(i, el){
					if( $( this ).data("dejavnost") == dejavnostID ) {
						$( this ).show();
					} else {
						$( this ).hide();
					}
				});
			}
			
		}
	}

	function repopulateWithCategory(dejavnostID) {
		//Remove all markers
		$('#map .marker').remove();
		$('#map .city-names').remove();
		$.ajax({ 
		   url: "/wp-json/wp/v2/prakse-api?per_page=100" + ( dejavnostID == 0 ? "" : "&dejavnost=" + dejavnostID ),
		   success: function(data){        
		     initPins(data, false );
		     filterFeed( dejavnostID );
		   }
		});
	}

	//When dropdown changes, repopulate markers
	$('.filter-dejavnosti select').on('change', function() {
		var dejavnostID = $( this ).find(":selected").val();
		repopulateWithCategory(dejavnostID);
	});

	$('.close-sidebar').on('click', function(){
		closeSideDetails();
	});

	$( window ).resize(function() {
		$( ".info-box" ).hide();
	});

	//Scroll into view
	function isScrolledIntoView(elem) {
	    var docViewTop = $(window).scrollTop();
	    var docViewBottom = docViewTop + $(window).height();

	    var elemTop = $(elem).offset().top;
	    var elemBottom = elemTop + $(elem).height()/2;

	    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
	}

	window.onscroll = function() {
		if( $('.home .featured-posts-header').length ) {
			var isImgInView = isScrolledIntoView( $('.home .featured-posts-header') );
			if( isImgInView ) {
			    $('.home .featured-posts-header').addClass('visible');
			}
		}
	};

	window.onload = setTimeout(function(){
		if( $('.header-post-title-container').length ) {
			$('.header-post-title-container').addClass('visible');
		}
	}, 700);

	$('.read-more-novice').click(function(){
		$('.hidden-wrapper.novice').show();
		$( this ).hide();
	});

	$('.read-more-dogodki').click(function(){
		$('.hidden-wrapper.dogodki').show();
		$( this ).hide();
	});

});